module.exports = __webpack_public_path__ + "static/media/42siliconvalley_logo.74ce27d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/brand-logos/42siliconvalley_logo.png
// module id = 1063
// module chunks = 0